import React from "react";

const Geonorge = () => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 55 55"
  >
    <polygon id="svg_4" points="20.9,30.4 20.9,54.5 0,42.4" fill="#4D4D4F" />
    <polygon
      id="svg_5"
      points="20.9,6.3 20.9,30.4 0,18.3 20.9,6.3"
      fill="#A6A8AB"
    />
    <polyline
      id="svg_6"
      points="20.9,30.4 41.8,42.4 41.8,18.3 20.9,30.4"
      fill="#BBBDBF"
    />
    <polyline
      id="svg_7"
      points="20.9,30.4 0,42.4 0,18.3 20.9,30.4"
      fill="#6D6E70"
    />
    <polyline
      id="svg_8"
      points="20.9,30.4 20.9,54.5 41.8,42.4 20.9,30.4"
      fill="#929497"
    />
    <path
      id="svg_9"
      d="m24.5,9.1c-0.1,-1.6 0.3,-3.2 1.2,-4.7c2.4,-4.2 7.8,-5.6 12,-3.2s5.6,7.8 3.2,12c-0.9,1.5 -2.1,2.6 -3.5,3.4l-12.9,7.4l0,-14.9zm13,2.1c1.4,-2.4 0.6,-5.4 -1.8,-6.7c-2.3,-1.4 -5.3,-0.5 -6.7,1.8c-0.5,0.8 -0.7,1.7 -0.7,2.6c0.1,1.6 0.9,3.2 2.5,4.1c1.5,0.9 3.3,0.9 4.8,0.1c0.8,-0.4 1.5,-1 1.9,-1.9z"
      fill="#FE5000"
    />
  </svg>
);

export default Geonorge;
